import * as React from 'react'
import { Header } from './Header'
import { ConfiguratorHeader } from './ConfiguratorHeader'
import {UserState} from "App/user";
import {isIE} from 'react-device-detect';

export interface PageContainerProps {
    user: UserState | null
    headerFragment?: React.ReactNode
    navFragment?: React.ReactNode
    mainFragment?: React.ReactNode
    footerFragment?: React.ReactNode
}

export class PageLayout extends React.PureComponent<PageContainerProps> {
    render () {
        const {headerFragment, navFragment, mainFragment, footerFragment} = this.props;

        return (
            <React.Fragment>
                {headerFragment ? 
                <header className="header-content">
                    {headerFragment}
                </header> : null}

                {navFragment ? 
                <nav className="stepbar">
                    {navFragment}
                </nav> : null}

                <div className="main-content">

                    <div className="row">
                        {/* Main content */}
                        {
                            isIE?
                                <div className="col mr-auto main-body">
                                    {mainFragment}
                                </div>:
                                <main className="col mr-auto main-body">
                                    {mainFragment}
                                </main>
                        }
                    </div>
                </div>
                {footerFragment ? 
                    <footer className="footer" role="contentinfo">
                        {footerFragment}
                    </footer>
                : null}
            </React.Fragment>
        );
    }
}

/** 
 * Creates an instance of the page layout with pre-configured headers and footers
*/
export class DefaultPageLayout extends React.PureComponent<PageContainerProps>{

    header() { return <Header/>}

    navFragment() {
        const { user } = this.props;
        return <ConfiguratorHeader user={user}/>
    }

    render () {
        return <PageLayout { ...{ headerFragment: this.header(), navFragment: this.navFragment(), ...this.props} } />
    }
}






// WEBPACK FOOTER //
// ./src/fragments/PageLayout.tsx